import { useMutation, useQuery } from "@tanstack/react-query";
import { useTRPC } from "../../../shared/api/trpc";
import type { IntakeSubmission } from "../ui/intake-form";

// Anonymous access to a public intake form: the capability token is the
// whole authorization, no session involved.
export function usePublicForm(token: string) {
  const trpcClient = useTRPC();
  const formQuery = useQuery(trpcClient.forms.read.queryOptions({ token }, { retry: false }));
  const submitMutation = useMutation(trpcClient.forms.submit.mutationOptions());

  return {
    data: formQuery.data ?? null,
    isError: formQuery.isError,
    isPending: formQuery.isPending,
    submit: (input: IntakeSubmission) => submitMutation.mutateAsync({ ...input, token }),
  };
}
